import React, { Fragment } from 'react'

const BkFlowEditGuestToggle = props => {
  const {
    currentCats,
    currentDogs,
    currentGuestData,
    hotelLabels,
    isCatsFieldVisible,
    isDogsFieldVisible
  } = props

  return (
    <Fragment>
      <div className="bk-flow-edit-guest__field-col adults col-xs">
        <p className="h4">{ currentGuestData && currentGuestData.adults ? currentGuestData.adults : '--' }</p>
        <p className="u-font-xs u-remove-margin">
          { currentGuestData && (Number(currentGuestData.adults) === 0 || Number(currentGuestData.adults) > 1) ?
            hotelLabels.adults ? hotelLabels.adults : 'Adults'
          :
            hotelLabels.adult ? hotelLabels.adult : 'Adult'
          }
        </p>
      </div>

      <div className="bk-flow-edit-guest__field-col children col-xs">
        <p className="h4">{ currentGuestData && currentGuestData.children >= 0 ? currentGuestData.children : '--' }</p>
        <p className="u-font-xs u-remove-margin">
          { currentGuestData && (Number(currentGuestData.children) === 0 || Number(currentGuestData.children) > 1) ?
            hotelLabels.children ? hotelLabels.children : 'Children'
          :
            hotelLabels.child ? hotelLabels.child : 'Child'
          }
        </p>
      </div>

      { (isDogsFieldVisible || isCatsFieldVisible) &&
        <div className="bk-flow-edit-guest__field-col pets col-xs">
          <p className="h4">{ currentCats + currentDogs }</p>
          <p className="u-font-xs u-remove-margin">{ hotelLabels.pets ? hotelLabels.pets : 'Pets' }</p>
        </div>
      }

      <i className="bk-flow-edit-guest__field-toggle-arrow material-icons">arrow_drop_down</i>
    </Fragment>
  )
}

export default BkFlowEditGuestToggle



// WEBPACK FOOTER //
// ./src/components/edit/guest/layouts/BkFlowEditGuestToggle.js